module.exports = __webpack_public_path__ + "static/projekt_indywidualny_a01-31b50c08f96103b085947d3ca7321c35.jpg";